import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import React, { useEffect, useState } from 'react'
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
  Card,
  Badge,
  Alert,
} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode'
import { Search, Printer, Package, TrendingUp, DollarSign } from 'lucide-react'

const RelatorioProdutos = () => {
  const [data1, setData1] = useState('')
  const [data2, setData2] = useState('')
  const [status, setStatus] = useState('')
  const [id_loja, setConta] = useState('')
  const [resultados, setResultados] = useState([])
  const [contas, setContas] = useState([])
  const [statuses, setStatuses] = useState([])
  const [loading, setLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(0)
  const itemsPerPage = 50
  const [agrupamento, setAgrupamento] = useState('normal') // normal | abc




  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const response = await apinode.get(
          `/pedido/contas/${localStorage.idconta}`,
        )
        setContas(response.data)
      } catch (error) {
        console.error('Erro ao buscar contas:', error)
      }
    }

    const fetchStatuses = async () => {
      try {
        const response = await apinode.get('/statuses')
        setStatuses(response.data)
      } catch (error) {
        console.error('Erro ao buscar os status:', error)
      }
    }

    fetchAccounts()
    fetchStatuses()
  }, [])

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value)
  }

  const formatQuantity = (quantity) => {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(quantity)
  }

  const handleStatusChange = (event) => {
    setStatus(event.target.value)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)

    try {
      const response = await apinode.get(
        `relprodutos/relatorio_produtos/${localStorage.idconta}`,
        {
          params: { id_loja, data1, data2, status },
        },
      )
      setResultados(response.data)
      setCurrentPage(0)
    } catch (error) {
      console.error('Erro ao buscar os dados:', error)
    } finally {
      setLoading(false)
    }
  }

  const calculateSubtotal = () => {
    return resultados.reduce((acc, item) => {
      if (item.status !== 'Cancelado') {
        return acc + (item.valor_novo || 0)
      }
      return acc
    }, 0)
  }


  const gerarCurvaABC = (dados) => {
    // 1. Agrupar por SKU (ou código do produto)
    const agrupados = dados.reduce((acc, item) => {
      const key = item.codigo || item.sku || item.descricao
  
      if (!acc[key]) {
        acc[key] = {
          codigo: item.codigo,
          descricao: item.descricao,
          quantidade: 0,
          total_custo: 0,
          total_venda: 0,
        }
      }
  
      acc[key].quantidade += item.quantidade_nova || 0
      acc[key].total_custo += (item.total_custo || 0)
      acc[key].total_venda += (item.valor_novo || 0)
  
      return acc
    }, {})
  
    // 2. Transformar em array
    const lista = Object.values(agrupados)
  
    // 3. Ordenar pela quantidade (decrescente)
    const ordenados = lista.sort((a, b) => b.quantidade - a.quantidade)
  
    // 4. Calcular participação acumulada sobre quantidade
    const totalQtd = ordenados.reduce((acc, item) => acc + item.quantidade, 0)
  
    let acumulado = 0
    return ordenados.map((item) => {
      acumulado += item.quantidade
      const percAcumulado = (acumulado / totalQtd) * 100
  
      let classe = 'C'
      if (percAcumulado <= 80) classe = 'A'
      else if (percAcumulado <= 95) classe = 'B'
  
      return {
        ...item,
        percAcumulado: percAcumulado.toFixed(2),
        classe,
      }
    })
  }
  

  const printPDF = () => {
    const formatDate = (date) => {
      const adjustedDate = new Date(date)
      adjustedDate.setMinutes(
        adjustedDate.getMinutes() + adjustedDate.getTimezoneOffset(),
      )
      return adjustedDate.toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
      })
    }

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value)
    }

    const formatQuantity = (value) => {
      return value.toLocaleString('pt-BR')
    }

    const totalCusto = resultados.reduce((acc, item) => {
      if (item.status !== 'Cancelado') {
        return acc + (item.total_custo || 0)
      }
      return acc
    }, 0)

    const totalVenda = resultados.reduce((acc, item) => {
      if (item.status !== 'Cancelado') {
        return acc + (item.valor_novo || 0)
      }
      return acc
    }, 0)

    const lucro = totalVenda - totalCusto
    const margemLucro = totalVenda > 0 ? ((lucro / totalVenda) * 100).toFixed(2) : 0

    const documentDefinition = {
      pageOrientation: 'landscape',
      pageSize: 'A4',
      pageMargins: [20, 60, 20, 60],

      // Cabeçalho em todas as páginas
      header: (currentPage, pageCount) => {
        return {
          margin: [20, 15, 20, 0],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  border: [false, false, false, true],
                  borderColor: ['#667eea', '#667eea', '#667eea', '#667eea'],
                  borderWidth: [0, 0, 0, 2],
                  stack: [
                    {
                      text: 'RELATÓRIO DE PRODUTOS',
                      style: 'headerTitle',
                      color: '#667eea'
                    },
                    {
                      text: `Página ${currentPage} de ${pageCount}`,
                      style: 'headerSubtitle',
                      margin: [0, 2, 0, 5]
                    }
                  ]
                }
              ]
            ]
          }
        }
      },

      // Rodapé em todas as páginas
      footer: (currentPage, pageCount) => {
        return {
          margin: [20, 10, 20, 15],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  border: [false, true, false, false],
                  borderColor: ['#667eea', '#667eea', '#667eea', '#667eea'],
                  borderWidth: [0, 2, 0, 0],
                  stack: [
                    {
                      text: `Gerado em: ${new Intl.DateTimeFormat('pt-BR', {
                        dateStyle: 'full',
                        timeStyle: 'short'
                      }).format(new Date())}`,
                      style: 'footerText',
                      margin: [0, 5, 0, 0]
                    }
                  ]
                }
              ]
            ]
          }
        }
      },

      content: [
        // Informações do Filtro
        {
          table: {
            widths: ['25%', '25%', '25%', '25%'],
            body: [
              [
                {
                  text: 'INFORMAÇÕES DO RELATÓRIO',
                  style: 'sectionTitle',
                  colSpan: 4,
                  fillColor: '#f8f9fa',
                  border: [true, true, true, false]
                },
                {}, {}, {}
              ],
              [
                {
                  stack: [
                    { text: 'Período:', style: 'infoLabel' },
                    { text: `${formatDate(data1)} até ${formatDate(data2)}`, style: 'infoValue' }
                  ],
                  fillColor: '#ffffff',
                  margin: [5, 5, 5, 5]
                },
                {
                  stack: [
                    { text: 'Status:', style: 'infoLabel' },
                    { text: status === '' || status === 'Todos' ? 'Todos' : status, style: 'infoValue' }
                  ],
                  fillColor: '#ffffff',
                  margin: [5, 5, 5, 5]
                },
                {
                  stack: [
                    { text: 'Conta:', style: 'infoLabel' },
                    { text: contas.find((conta) => conta.ID_CONTA === id_loja)?.APELIDO || 'Não Selecionado', style: 'infoValue' }
                  ],
                  fillColor: '#ffffff',
                  margin: [5, 5, 5, 5]
                },
                {
                  stack: [
                    { text: 'Total de Itens:', style: 'infoLabel' },
                    { text: resultados.length.toString(), style: 'infoValue' }
                  ],
                  fillColor: '#ffffff',
                  margin: [5, 5, 5, 5]
                }
              ]
            ]
          },
          margin: [0, 0, 0, 15]
        },

        // Tabela de Produtos
        {
          table: {
            headerRows: 1,
            widths: ['6%', '6%', '18%', '8%', '8%', '6%', '8%', '9%', '6%', '15%', '10%'],
            body: [
              [
                { text: 'Data', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'SKU', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Descrição', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Vlr. Unit.', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Custo Unit.', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Qtde', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Total Custo', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Total Venda', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Pedido', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Cliente - CPF', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' },
                { text: 'Status', style: 'tableHeader', fillColor: '#667eea', color: '#ffffff' }
              ],
              ...resultados.map((item, index) => [
                {
                  text: formatDate(item.data) || '-',
                  style: 'tableContent',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: item.codigo || '-',
                  style: 'tableContentBold',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: item.descricao || '-',
                  style: 'tableContent',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: formatCurrency(item.valorunitario) || '-',
                  style: 'tableContentRight',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: formatCurrency(item.preco_custo) || '-',
                  style: 'tableContentRight',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: formatQuantity(item.quantidade_nova) || '-',
                  style: 'tableContentCenter',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: formatCurrency(item.total_custo) || '-',
                  style: 'tableContentRight',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                  color: item.total_custo === 0 || item.total_custo === null ? '#856404' : '#000000'
                },
                {
                  text: formatCurrency(item.valor_novo) || '-',
                  style: 'tableContentRightBold',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                  color: '#155724'
                },
                {
                  text: item.pedido || '-',
                  style: 'tableContentCenter',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: `${item.cliente || '-'}\n${item.cpf || '-'}`,
                  style: 'smallText',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa'
                },
                {
                  text: item.status || '-',
                  style: 'tableContentCenter',
                  fillColor: index % 2 === 0 ? '#ffffff' : '#f8f9fa',
                  color: item.status === 'Cancelado' ? '#721c24' : item.status === 'Atendido' ? '#155724' : '#000000'
                }
              ])
            ]
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#dee2e6',
            vLineColor: () => '#dee2e6',
            paddingLeft: () => 4,
            paddingRight: () => 4,
            paddingTop: () => 3,
            paddingBottom: () => 3
          }
        },

        // Resumo Financeiro
        {
          margin: [0, 15, 0, 0],
          table: {
            widths: ['*', '20%'],
            body: [
              [
                {
                  text: 'RESUMO FINANCEIRO',
                  style: 'sectionTitle',
                  colSpan: 2,
                  fillColor: '#f8f9fa',
                  border: [true, true, true, false]
                },
                {}
              ],
              [
                { text: 'Total em Custos:', style: 'summaryLabel', fillColor: '#ffffff' },
                { text: formatCurrency(totalCusto), style: 'summaryValue', fillColor: '#fff3cd', alignment: 'right', color: '#856404' }
              ],
              [
                { text: 'Total em Vendas:', style: 'summaryLabel', fillColor: '#ffffff' },
                { text: formatCurrency(totalVenda), style: 'summaryValue', fillColor: '#d4edda', alignment: 'right', color: '#155724' }
              ],
              [
                { text: 'Lucro Bruto:', style: 'summaryLabelBold', fillColor: '#ffffff' },
                { text: formatCurrency(lucro), style: 'summaryValueBold', fillColor: lucro >= 0 ? '#d4edda' : '#f8d7da', alignment: 'right', color: lucro >= 0 ? '#155724' : '#721c24' }
              ],
              [
                { text: 'Margem de Lucro:', style: 'summaryLabelBold', fillColor: '#ffffff' },
                { text: `${margemLucro}%`, style: 'summaryValueBold', fillColor: '#e7f3ff', alignment: 'right', color: '#004085' }
              ]
            ]
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#dee2e6',
            vLineColor: () => '#dee2e6'
          }
        },

        // Observações
        {
          margin: [0, 10, 0, 0],
          table: {
            widths: ['*'],
            body: [
              [
                {
                  stack: [
                    { text: 'OBSERVAÇÕES IMPORTANTES:', style: 'noteTitle' },
                    {
                      ul: [
                        'Pedidos com status "Cancelado" são listados mas não entram nos cálculos de totais.',
                        'Os valores apresentados refletem apenas os pedidos não cancelados.',
                        'A margem de lucro é calculada sobre o total de vendas (Lucro / Vendas × 100).',
                        'Produtos com custo total zerado ou nulo aparecem destacados em amarelo.'
                      ],
                      style: 'noteText'
                    }
                  ],
                  fillColor: '#fff3cd',
                  border: [true, true, true, true],
                  borderColor: ['#ffc107', '#ffc107', '#ffc107', '#ffc107']
                }
              ]
            ]
          }
        }
      ],

      styles: {
        headerTitle: {
          fontSize: 18,
          bold: true,
          alignment: 'center'
        },
        headerSubtitle: {
          fontSize: 8,
          alignment: 'center',
          color: '#6c757d'
        },
        footerText: {
          fontSize: 7,
          alignment: 'center',
          color: '#6c757d'
        },
        sectionTitle: {
          fontSize: 10,
          bold: true,
          alignment: 'center',
          margin: [0, 5, 0, 5]
        },
        infoLabel: {
          fontSize: 7,
          color: '#6c757d',
          bold: true
        },
        infoValue: {
          fontSize: 9,
          margin: [0, 2, 0, 0]
        },
        tableHeader: {
          fontSize: 8,
          bold: true,
          alignment: 'center',
          margin: [0, 2, 0, 2]
        },
        tableContent: {
          fontSize: 7,
          alignment: 'left'
        },
        tableContentBold: {
          fontSize: 7,
          alignment: 'left',
          bold: true
        },
        tableContentCenter: {
          fontSize: 7,
          alignment: 'center'
        },
        tableContentRight: {
          fontSize: 7,
          alignment: 'right'
        },
        tableContentRightBold: {
          fontSize: 7,
          alignment: 'right',
          bold: true
        },
        smallText: {
          fontSize: 6,
          alignment: 'left',
          lineHeight: 1.2
        },
        summaryLabel: {
          fontSize: 9,
          margin: [5, 3, 5, 3]
        },
        summaryLabelBold: {
          fontSize: 10,
          bold: true,
          margin: [5, 3, 5, 3]
        },
        summaryValue: {
          fontSize: 9,
          margin: [5, 3, 5, 3]
        },
        summaryValueBold: {
          fontSize: 11,
          bold: true,
          margin: [5, 3, 5, 3]
        },
        noteTitle: {
          fontSize: 8,
          bold: true,
          margin: [5, 5, 5, 3],
          color: '#856404'
        },
        noteText: {
          fontSize: 7,
          margin: [5, 3, 5, 5],
          color: '#856404'
        }
      }
    }

    pdfMake.createPdf(documentDefinition).open()
  }

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
    return new Intl.DateTimeFormat('pt-BR', options).format(
      new Date(dateString),
    )
  }

  const handlePageClick = (data) => {
    setCurrentPage(data.selected)
  }

  const calculateTotalCost = () => {
    return resultados.reduce((acc, item) => {
      if (item.status !== 'Cancelado') {
        return acc + item.preco_custo * item.quantidade_nova
      }
      return acc
    }, 0)
  }

  const getStatusBadge = (status) => {
    const statusColors = {
      'Atendido': 'success',
      'Cancelado': 'danger',
      'Aguardando': 'warning',
      'Em aberto': 'info',
      'Pago': 'success',
      'Atrasado': 'danger',
    }
    return statusColors[status] || 'secondary'
  }
  
 
  const offset = currentPage * itemsPerPage
const dadosFiltrados = agrupamento === 'abc' ? gerarCurvaABC(resultados) : resultados
const currentItems = dadosFiltrados.slice(offset, offset + itemsPerPage)
const pageCount = Math.ceil(dadosFiltrados.length / itemsPerPage)


  return (
    <>
      <Navbar />

      <Container className="mt-page py-4">
        {/* Cabeçalho Moderno */}
        <div className="mb-4">
          <div className="d-flex align-items-center mb-2">
            <Package size={40} className="text-primary me-3" />
            <div>
              <h1 className="display-5 fw-bold text-primary mb-0">
                Relatório de Produtos
              </h1>
              <p className="text-muted mb-0">
                Visualize e analise os produtos vendidos no período selecionado
              </p>
            </div>
          </div>
        </div>

        {/* Card de Filtros com Design Moderno */}
        <Card className="shadow-sm border-0 mb-4">
          <Card.Header className="bg-gradient text-white" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
            <div className="d-flex align-items-center">
              <Search size={20} className="me-2" />
              <h5 className="mb-0">Filtros de Pesquisa</h5>
            </div>
          </Card.Header>
          <Card.Body className="p-4">
            <Form onSubmit={handleSubmit}>
              <Row className="g-3">
                <Col md={6} lg={3}>
                  <Form.Group controlId="conta">
                    <Form.Label className="fw-semibold text-secondary small">
                      CONTA
                    </Form.Label>
                    <Form.Select
                      value={id_loja}
                      onChange={(e) => setConta(e.target.value)}
                      className="form-select shadow-sm"
                      style={{ borderRadius: '8px' }}
                    >
                      <option value="">Selecione a conta</option>
                      {contas.map((conta) => (
                        <option key={conta.ID_CONTA} value={conta.ID_CONTA}>
                          {conta.APELIDO}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={6} lg={3}>
                  <Form.Group controlId="data1">
                    <Form.Label className="fw-semibold text-secondary small">
                      DATA INICIAL
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={data1}
                      onChange={(e) => setData1(e.target.value)}
                      className="shadow-sm"
                      style={{ borderRadius: '8px' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6} lg={3}>
                  <Form.Group controlId="data2">
                    <Form.Label className="fw-semibold text-secondary small">
                      DATA FINAL
                    </Form.Label>
                    <Form.Control
                      type="date"
                      value={data2}
                      onChange={(e) => setData2(e.target.value)}
                      className="shadow-sm"
                      style={{ borderRadius: '8px' }}
                    />
                  </Form.Group>
                </Col>

                <Col md={6} lg={3}>
                  <Form.Group controlId="status">
                    <Form.Label className="fw-semibold text-secondary small">
                      STATUS
                    </Form.Label>
                    <Form.Select
                      value={status}
                      onChange={handleStatusChange}
                      className="shadow-sm"
                      style={{ borderRadius: '8px' }}
                    >
                      <option value="Todos">Todos</option>
                      <option value="Aguardando">Aguardando</option>
                      <option value="Em aberto">Em aberto</option>
                      <option value="Atendido">Atendido</option>
                      <option value="Cancelado">Cancelado</option>
                      <option value="Ag. conf.">Ag. conferência</option>
                      <option value="Ag. Definição">Ag. Definição</option>
                      <option value="ERRO IMPRESSAO">Erro de Impressão</option>
                      <option value="Em conferência">Em conferência</option>
                      <option value="Atrasado">Atrasado</option>
                      <option value="Ag. Entrega">Ag. Entrega</option>
                      <option value="Ag. Produto">Ag. Produto</option>
                      <option value="Ag. Pagamento">Ag. Pagamento</option>
                      <option value="Pago">Pago</option>
                      <option value="Boleto">Boleto</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mt-4">
                <Col className="d-flex gap-2 justify-content-end">
                  <Button
                    variant="primary"
                    type="submit"
                    className="px-4 shadow-sm d-flex align-items-center gap-2"
                    style={{ borderRadius: '8px' }}
                  >
                    <Search size={18} />
                    Filtrar
                  </Button>
                  <Button
                    variant="success"
                    onClick={printPDF}
                    disabled={resultados.length === 0}
                    className="px-4 shadow-sm d-flex align-items-center gap-2"
                    style={{ borderRadius: '8px' }}
                  >
                    <Printer size={18} />
                    Imprimir PDF
                  </Button>
                </Col>
              </Row>
            </Form>
          </Card.Body>
        </Card>

        {/* Cards de Resumo com Ícones */}
        {resultados.length > 0 && !loading && (
          <Row className="mb-4 g-3">
            <Col md={4}>
              <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle p-3 me-3"
                      style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
                    >
                      <Package size={28} className="text-white" />
                    </div>
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1 fw-semibold">TOTAL DE PRODUTOS</p>
                      <h3 className="mb-0 fw-bold">{resultados.length}</h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle p-3 me-3"
                      style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}
                    >
                      <TrendingUp size={28} className="text-white" />
                    </div>
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1 fw-semibold">TOTAL CUSTO</p>
                      <h3 className="mb-0 fw-bold text-danger">
                        {formatCurrency(calculateTotalCost())}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="border-0 shadow-sm h-100" style={{ borderRadius: '12px' }}>
                <Card.Body>
                  <div className="d-flex align-items-center">
                    <div
                      className="rounded-circle p-3 me-3"
                      style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}
                    >
                      <DollarSign size={28} className="text-white" />
                    </div>
                    <div className="flex-grow-1">
                      <p className="text-muted small mb-1 fw-semibold">TOTAL VENDA</p>
                      <h3 className="mb-0 fw-bold text-success">
                        {formatCurrency(calculateSubtotal())}
                      </h3>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={3}>
              <Form.Group controlId="agrupamento">
                <Form.Label className="fw-semibold text-secondary small">Agrupar por</Form.Label>
                <Form.Select
                  value={agrupamento}
                  onChange={(e) => setAgrupamento(e.target.value)}
                  className="shadow-sm"
                  style={{ borderRadius: '8px' }}
                >
                  <option value="normal">Normal</option>
                  <option value="abc">Curva ABC</option>
                </Form.Select>
              </Form.Group>
            </Col>

          </Row>
        )}

        {/* Tabela de Resultados */}
        <Card className="shadow-sm border-0" style={{ borderRadius: '12px' }}>
          <Card.Header className="bg-light border-0" style={{ borderRadius: '12px 12px 0 0' }}>
            <h5 className="mb-0 fw-bold text-dark">📋 Resultados da Pesquisa</h5>
          </Card.Header>
          <Card.Body className="p-0">
            {loading ? (
              <div className="d-flex flex-column justify-content-center align-items-center py-5">
                <Spinner animation="border" variant="primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                  <span className="visually-hidden">Carregando...</span>
                </Spinner>
                <p className="mt-3 text-muted fw-semibold">Carregando dados...</p>
              </div>
            ) : resultados.length === 0 ? (
              <div className="text-center py-5">
                <div
                  className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                  style={{ width: '80px', height: '80px', background: '#f8f9fa' }}
                >
                  <Package size={40} className="text-muted" />
                </div>
                <h5 className="text-muted">Nenhum resultado encontrado</h5>
                <p className="text-muted">Use os filtros acima para pesquisar produtos</p>
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <Table hover className="mb-0">
                    <thead style={{ background: '#f8f9fa' }}>
                      <tr>
                        <th className="text-nowrap fw-semibold small border-0">Data</th>
                        <th className="text-nowrap fw-semibold small border-0">Cliente</th>
                        <th className="text-nowrap fw-semibold small border-0">SKU</th>
                        <th className="fw-semibold small border-0">Descrição</th>
                        <th className="text-end text-nowrap fw-semibold small border-0">Custo Unit.</th>
                        <th className="text-end text-nowrap fw-semibold small border-0">Valor Unit.</th>
                        <th className="text-center text-nowrap fw-semibold small border-0">Qtde</th>
                        <th className="text-end text-nowrap fw-semibold small border-0">Custo Total</th>
                        <th className="text-end text-nowrap fw-semibold small border-0">Vlr. Total</th>
                        <th className="text-center text-nowrap fw-semibold small border-0">Pedido</th>
                        <th className="text-center text-nowrap fw-semibold small border-0">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item, index) => (
                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                          <td className="text-nowrap align-middle">
                            <small className="text-muted">{formatDate(item.data)}</small>
                          </td>
                          <td className="align-middle">
                            <div>
                              <div className="fw-semibold small">{item.cliente}</div>
                              <div className="text-muted" style={{ fontSize: '0.75rem' }}>{item.cpf}</div>
                            </div>
                          </td>
                          <td className="align-middle">
                            <Badge bg="secondary" className="font-monospace" style={{ fontSize: '0.7rem' }}>
                              {item.codigo}
                            </Badge>
                          </td>
                          <td className="align-middle">
                            <small>{item.descricao}</small>
                          </td>
                          <td className="text-end align-middle">
                            <small className="text-muted">{formatCurrency(item.preco_custo)}</small>
                          </td>
                          <td className="text-end align-middle">
                            <small className="fw-semibold">{formatCurrency(item.valorunitario)}</small>
                          </td>
                          <td className="text-center align-middle">
                            <Badge bg="info" style={{ fontSize: '0.75rem' }}>
                              {formatQuantity(item.quantidade_nova)}
                            </Badge>
                          </td>
                          <td className="text-end align-middle">
                            <Badge
                              bg={
                                item.total_custo === 0 ||
                                  item.total_custo === null
                                  ? 'warning'
                                  : 'secondary'
                              }
                              text={
                                item.total_custo === 0 ||
                                  item.total_custo === null
                                  ? 'dark'
                                  : 'white'
                              }
                              style={{ fontSize: '0.75rem' }}
                            >
                              {formatCurrency(item.total_custo)}
                            </Badge>
                          </td>
                          <td className="text-end align-middle">
                            <small className="fw-bold text-success">{formatCurrency(item.valor_novo)}</small>
                          </td>
                          <td className="text-center align-middle">
                            <Badge bg="primary" style={{ fontSize: '0.75rem' }}>{item.pedido}</Badge>
                          </td>
                          <td className="text-center align-middle">
                            <Badge bg={getStatusBadge(item.status)} style={{ fontSize: '0.7rem' }}>
                              {item.status}
                            </Badge>
                          </td>
                          <td className="text-center align-middle">
                            {agrupamento === 'abc' && (
                              <Badge bg={item.classe === 'A' ? 'success' : item.classe === 'B' ? 'warning' : 'secondary'}>
                                {item.classe}
                              </Badge>
                            )}
                          </td>

                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* Alerta sobre cancelados */}
                <Alert variant="warning" className="m-3 mb-0 border-0 shadow-sm" style={{ borderRadius: '8px' }}>
                  <div className="d-flex align-items-start">
                    <span className="me-2">ℹ️</span>
                    <div>
                      <strong>Atenção:</strong> Pedidos cancelados podem ser listados, mas não entram na soma final dos produtos.
                    </div>
                  </div>
                </Alert>

                {/* Paginação */}
                {pageCount > 1 && (
                  <div className="d-flex justify-content-center p-3">
                    <ReactPaginate
                      previousLabel={'← Anterior'}
                      nextLabel={'Próximo →'}
                      breakLabel={'...'}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination mb-0'}
                      pageClassName={'page-item'}
                      pageLinkClassName={'page-link'}
                      previousClassName={'page-item'}
                      previousLinkClassName={'page-link'}
                      nextClassName={'page-item'}
                      nextLinkClassName={'page-link'}
                      breakClassName={'page-item'}
                      breakLinkClassName={'page-link'}
                      activeClassName={'active'}
                      forcePage={currentPage}
                    />
                  </div>
                )}
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </>
  )
}

export default RelatorioProdutos